module.exports = __webpack_public_path__ + "static/media/file-bmp.34446bfe.svg";